import PropTypes from "prop-types"

import { cn } from "styles/utils"

const Shimmer = ({ className, ...props }) => (
  <div
    className={cn(
      "animate-shimmer overflow-hidden bg-[linear-gradient(to_right,#eee_8%,#ddd_18%,#eee_33%)] bg-[length:800px_100px] bg-[position:0_0]",
      className
    )}
    {...props}
  />
)

Shimmer.propTypes = {
  className: PropTypes.string,
}

export default Shimmer
